<alii-web-spinner-loading *ngIf="loading$ | async"></alii-web-spinner-loading>
<div *ngIf="!(loading$ | async)">
    <h1>Dashboards</h1>
    <h1>Protocol views and user logins</h1>
    <p>Statictics graph here</p>
</div>
